import styled from 'styled-components';
import { SummaryContainer } from '../containers';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { useEffect, useState } from 'react';
import COLORS from '../../colors';
import { mapPascalMonthToLowercaseMonth } from '../../util';
import { MONTH_PASCAL } from '../../constants';
import { getMonthsInRange } from '../../services/date';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 50%;
  margin-bottom: 16px;
  margin-top: 16px;
`;

const Column = styled.div`
  flex: 1;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

const StyledTableHeading = styled.p`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13.33px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${COLORS.NEUTRAL_500};
  padding: 0 12px;
`;

const StyledTableHeadingSmall = styled.p`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 13.33px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${COLORS.NEUTRAL_500};
  padding: 0 12px;
  max-width: 60px;
`;

const StyledItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${COLORS.NEUTRAL_200};
  padding: 12px;
  background-color: ${COLORS.NEUTRAL_925};
  border-radius: 8px;
`;

const AdMirroring = () => {
  const { demographic } = useAppSelector((state: RootState) => state.detail);
  const monthData = useAppSelector((state: RootState) => state.calculated);

  const { startDate, endDate } = useAppSelector(
    (state: RootState) => state.detail.campaignLength
  );

  const [months, setMonths] = useState<string[]>([]);

  useEffect(() => {
    if (!startDate || !endDate) {
      return;
    }

    const monthsInRange = getMonthsInRange(
      new Date(startDate),
      new Date(endDate)
    );
    setMonths(monthsInRange);
  }, [startDate, endDate]);
  return (
    <StyledContainer>
      <SummaryContainer title="Platform Selection">
        <Column>
          <Row>
            <StyledTableHeadingSmall></StyledTableHeadingSmall>
            <StyledTableHeading>
              Broadcast Only or Cross Platform?
            </StyledTableHeading>
          </Row>
          {months.map((month) => {
            if (!month || !demographic) {
              return;
            }

            const selectedMonth = mapPascalMonthToLowercaseMonth(
              month as MONTH_PASCAL
            );

            return (
              <Row>
                <StyledTableHeadingSmall>{month}</StyledTableHeadingSmall>
                <StyledItem>
                  {monthData[selectedMonth].adMirroring.isAdMirroringEnabled
                    ? 'Cross Platform'
                    : 'Broadcast Only'}
                </StyledItem>
              </Row>
            );
          })}
        </Column>
      </SummaryContainer>
    </StyledContainer>
  );
};

export default AdMirroring;
